import React, { useEffect, useState } from 'react'
import { TooltipProps } from './types'
import {resolveProps} from '../../../utils'

const config = {
  types: [
    {
      title: 'top',
      isDefault: true
    },
    'topLeft',
    'topRight',
    'right',
    'rightTop',
    'rightBottom',
    'bottom',
    'bottomLeft',
    'bottomRight',
    'left',
    'leftTop',
    'leftBottom'
  ],
  modifiers: ['inverse'],
  states: []
}

export default function Tooltip(props: TooltipProps) {
  const {
    className,
    isVisible,
    children,
    icon,
    iconName,
    top,
    topLeft,
    topRight,
    left,
    leftTop,
    leftBottom,
    right,
    rightTop,
    rightBottom,
    bottom,
    bottomLeft,
    bottomRight,
    link,
    href,
    linkTitle,
    ...rest
  } = props

  const [visible, setVisible] = useState(isVisible)

  useEffect(() => {
    setVisible(isVisible)
  }, [isVisible])

  return (
    <div
      {...rest}
      className={`${resolveProps(props, config, 'Tooltip')} ${className}`}
      style={{ display: visible ? 'inline-flex' : 'none' }}
    >
      {icon ? (
        <div className="mdn-Text mdn-Tooltip--iconText">
          <i
            className={'mdn-Icon-' + iconName + ' mdn-Icon--sm'}
            aria-hidden="true"
          ></i>
          <>{children}</>
        </div>
      ) : link ? (
        <div className="mdn-Tooltip--Link">
          <div className="mdn-Text mdn-Tooltip--iconText">
            <span>{children}</span>
            <a
              className="mdn-Icon-fechar mdn-Icon--sm"
              aria-hidden="true"
              onClick={(e) => setVisible(false)}
            ></a>
          </div>
          <div className="mdn-Text">
            <a className="mdn-Link mdn-Link-anchor" href={href}>
              {linkTitle}
            </a>
          </div>
        </div>
      ) : (
        <p className="mdn-Text mdn-Text--caption mdn-Text--inverse">
          {children}
        </p>
      )}
    </div>
  )
}
